import { EImportEntity } from '../importer/model';
import { importReducer } from '../importer/reducer';

export const ancillaryActivitiesRatesImport = importReducer(EImportEntity.ANCILLARY_ACTIVITIES_RATES);
